import app, { Component } from 'apprun';
import { serializeObject, api } from './api';
import { isValid, showSaveStatusMessage, lookup_en } from './utils';

export default class SRegionComponent extends Component {
  state = { attributeValue: '', provStateCt: '' };
  // prettier-ignore
  view = (state) => {
    if (!state) {return;}

    return (
      <div>
        <form id="srNewForm">
          <div class="list-group">
            <div class="list-group-item">
              <label class="control-label">Region Name: </label>&nbsp;
              <input id="attributeValue" $bind name="attributeValue" class='pull-right' data-validate/>
              <div id="attributeValueErrMsg" class="text-danger"></div>
            </div>
            <div class="list-group-item">
              <label class="control-label">Province: </label>&nbsp;
              <select id="provStateCt" name="provStateCt" required="required" data-validate="Int-1">
                {lookup_en.ProvStateCt.map((r) => {
                  return (<option value={r.id}>{r.value}</option>);
                })}
              </select>
              <div id="provStateCtErrMsg" class="text-danger"></div>
            </div>
          </div>
        </form>
        <div class="edit-buttons">
          <button class="btn btn-primary btn-xs pull-right" onclick={() => this.run('save')} >Save</button>
        </div>
        <div>
          <label class={(state.saveMsg!=='Success')?'text-danger':''}>{state.saveMsg}</label>&nbsp;
        </div>
      </div>
    );
  }

  update = {
    save: async (state) => {
      const formName = 'srNewForm';
      if (!isValid(formName)) {return;}
      const formData = serializeObject(document.getElementById(formName));
      formData['attributeName'] = 'RegionsServiced';

      try {
        await api.invoke('POST', 'regionsserviced/AddLookupData', formData || {});
        state.saveMsg = 'Success';
        showSaveStatusMessage('service area');
      } catch (ex) {
        state.saveMsg = await ex.json();
        showSaveStatusMessage();
      }

      return state;
    },

    cancel: (state) => {
      app.run('#clear-panel', state.panelId);
    }
  };

  rendered = () => {
    const form = document.getElementById('copmNewForm');
    if (form) {form.setAttribute('autocomplete', 'off');}
  };
}
